import { render, staticRenderFns } from "./AddNivel2.vue?vue&type=template&id=13f57132&"
import script from "./AddNivel2.vue?vue&type=script&lang=js&"
export * from "./AddNivel2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports